(function () {
    'use strict';

    angular
        .module('Lavpop-store.components')
        .controller('NotAuthorizedController', NotAuthorizedController)

    /** @ngInject */
    function NotAuthorizedController($rootScope) {
        const vm = this;

        init();

        function init() {
            $rootScope.hideLoading = true;
        }
    }
}());